var _desc, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInteractiveBusinessLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 960,
    height: 280,
    viewBox: "0 0 960 280",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "logoTitle"
  }, "Interactive Business Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "logoTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "logoDesc"
  }, "Interactive wordmark with pink ring accents and black Business text.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(480 105)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-80,-6 A80,56 0 0 1 80,-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-80,6 A80,56 0 0 0 80,6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52,-10 A52,38 0 0 1 52,-10",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52,10 A52,38 0 0 0 52,10",
    stroke: "#FFFFFF"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 145,
    textAnchor: "middle",
    fill: "#FF1B54",
    fontFamily: "Montserrat, Arial, sans-serif",
    fontWeight: 800,
    fontSize: 78,
    letterSpacing: 8
  }, "\n    INTERACTIVE\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 210,
    textAnchor: "middle",
    fill: "#000000",
    fontFamily: "Montserrat, Arial, sans-serif",
    fontWeight: 700,
    fontSize: 40,
    letterSpacing: 11
  }, "\n    BUSINESS\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractiveBusinessLogo);
export default __webpack_public_path__ + "static/media/InteractiveBusinessLogo.dc7f407c646e7030fde05c1ab562ae1e.svg";
export { ForwardRef as ReactComponent };